module.exports = __webpack_public_path__ + "static/media/Akemi_4331.44531042.jpg";